var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('generic-container',{ref:"container",staticStyle:{"margin-top":"15px"},attrs:{"title":_vm.$t('human task tester'),"icon":"magic wand","id":"cntnr","header_buttons":_vm.header_buttons,"show_refresh":true},on:{"refresh":_vm.refresh}},[_c('div',{staticClass:"ui form",attrs:{"id":"instance_form"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }